<div class="w-full min-h-screen bg-gray-100">
    <app-toast></app-toast>
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>